export default __webpack_public_path__ + "static/media/camera_inner_circle.b33726ef.svg";